<!--landing page-->
<page-embed *ngIf="!!marketingPage" [marketingPageInput]="marketingPage"></page-embed>

<!--fallback default landing page-->
<page-embed *ngIf="!marketingPage && !!marketingPageId" [marketingPageId]="marketingPageId"></page-embed>
